import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../api/apiClient';
import LoadingSpinner from '../../../components/ui/LoadingSpinner';
import ErrorBanner from '../../../components/ui/ErrorBanner';
import { formatDateTime } from '../../../utils/formatters';
import { st, colors } from '../shared/meetingStyles';
import Avatar from '../shared/Avatar';
import { MegaphoneIcon, XIcon } from '../shared/Icons';

export default function HeadlinesSection({ sessionId, meetingId }) {
  const [headlines, setHeadlines] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [text, setText] = useState('');
  const [ownerUserId, setOwnerUserId] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [headlinesRes, teamRes] = await Promise.all([
        apiClient.get('/meetings/headlines'),
        apiClient.get('/meetings/team'),
      ]);
      setHeadlines(headlinesRes.data.headlines || []);
      setTeam(teamRes.data.users || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addHeadline = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    await apiClient.post('/meetings/headlines', { text: text.trim(), owner_user_id: ownerUserId || null, meeting_id: meetingId, session_id: sessionId });
    setText('');
    await load();
  };
  const remove = async (id) => {
    if (!window.confirm('Delete this headline?')) return;
    await apiClient.delete(`/meetings/headlines/${id}`); await load();
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div style={st.card}>
      {error && <ErrorBanner message={error} />}
      <div style={st.cardHeader}>
        <h2 style={{ ...st.h2, display: 'flex', alignItems: 'center', gap: '0.5rem' }}><MegaphoneIcon size={18} /> Core Value Shout outs</h2>
      </div>
      <form onSubmit={addHeadline} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.9rem', padding: '0.85rem 1rem', background: colors.bgSubtle, borderRadius: '0.75rem', border: `1.5px solid ${colors.border}` }}>
        <select value={ownerUserId} onChange={e => setOwnerUserId(e.target.value)} style={{ ...st.input, width: '150px' }}>
          <option value="">No owner</option>
          {team.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
        </select>
        <input value={text} onChange={e => setText(e.target.value)} placeholder="Create a quick Headline" style={{ ...st.input, flex: 1 }} />
        <button type="submit" style={st.primaryBtn}>Add</button>
      </form>
      {headlines.length === 0 ? (
        <div style={st.emptyState}><MegaphoneIcon size={28} style={{ color: colors.faint }} />You have no active Headlines.</div>
      ) : (
        headlines.map(h => (
          <div key={h.id} style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', padding: '0.6rem 0.25rem', borderBottom: '1px solid #f1f5f9' }}>
            <Avatar name={h.owner_name} size={22} />
            <span style={{ flex: 1, fontSize: '0.8rem', color: colors.text }}>{h.text}</span>
            <span style={{ fontSize: '0.65rem', color: colors.faint }}>{formatDateTime(h.created_at)}</span>
            <button onClick={() => remove(h.id)} style={st.ghostBtn}><XIcon size={13} /></button>
          </div>
        ))
      )}
    </div>
  );
}
